import useCreateUser from './useCreateUser'
export default useCreateUser
